let isFirstInstance = true;

export function LandingController(
    cartDisplayService,
    performanceService,
    restaurantInfoFactory,
    $state,
    $q
) {
    'ngInject';
    var vm = this;
    vm.savedAddresses = [];
    vm.restaurantInfo = {};
    vm.$state = $state;

    activate();

    ///---------------------------------

    function _setRestaurantInfo(info) {
        vm.restaurantInfo = info;
    }

    function activate() {
        vm._startPerfTiming = performanceService.timingCategory('Landing Page');
        vm._endLoadingTiming = vm._startPerfTiming('Loading');

        // We don't need the cartDisplayData itself in this controller, but we
        // should show our spinner until it has loaded. Otherwise we'd see
        // start_order.component's spinner (the overall time would be the same).
        const cartDisplayDataPromise = cartDisplayService
            .getDisplayData()
            .finally(() => $q.resolve());

        $q.all([
            restaurantInfoFactory.getInfo([
                'general', 'restaurantAddress', 'imageSet'
            ]),
            cartDisplayDataPromise
        ]).then(function([restaurantInfo]) {
            _setRestaurantInfo(restaurantInfo);
        }).finally(() => {
            vm._endLoadingTiming({
                sendToAnalytics: isFirstInstance,
                analyticsLabel: 'complete',
                analyticsIncludeNavigationStart: true
            });
            isFirstInstance = false;
            vm.loadingComplete = true;
        });
    }
}
